import React, { useContext, useEffect, useState } from "react";
import Filter from "../components/common/Filter";
import RequestBuy from "../components/common/requestForm/RequestBuy";
import DiscountedProduct from "../components/common/DiscountedProduct";
import Products from "../components/common/Products";
import { useFormik } from "formik";
import ReactSlackChat from "react-slack-chat";
import { Helmet } from "react-helmet";
import { useParams, useSearchParams } from "react-router-dom";
import Storys from "../components/common/mobile/Storys";
import { FilterContext } from "../context/FilterContext";
import Modal from "@mui/material/Modal";
import { FaTimes } from "react-icons/fa";
import { httpReauest } from "../utils/httpRequest";
import FilterCategory from "../components/common/FilterCategory";
import ProductsMobile from "../components/common/mobile/ProductsMobile";
import CategoryPage from "./mobile/CategoryPage";
import CategoryPageSmallMobile from "./mobile/CategoryPageSmallMobile";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "#fff",
  boxShadow: 24,
  borderRadius: 10,
  minWidth: 300,
};

const Categorypage = ({ dealerData, mobile }) => {
  const { category } = useParams();
  const [loading, setloading] = useState(true);
  const [selectedCategory, setselectedCategory] = useState(false);
  const formik = useFormik({
    initialValues: {
      category: "",
      brand: "",
      search_type: "product",
    },
  });

  const filterData = useContext(FilterContext);

  const url = `https://1924.ir/${category}`;


  const {
    setfilter_category,
    filter_category,
    filter_brand,
    setfilter_brand,
    setfilter_search_type,
  } = filterData;

  async function getData(params) {
    await httpReauest("GET", "/category", {}, {}).then(({ data }) => {
      const newCategory = data.data.find((item) => item.url == category);
      setselectedCategory(newCategory);
      setfilter_category(newCategory?._id);
      formik.setFieldValue("category", newCategory?._id);
      setloading(false);
    });
  }

  useEffect(() => {
    getData();
  }, []);

  async function handleSubmit(e) {
    e?.preventDefault();
    setfilter_category(formik.values.category);
    setfilter_brand(formik.values.brand);
    setfilter_search_type(formik.values.search_type);
  }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{selectedCategory?.meta_title}</title>
        <meta name="description" content={selectedCategory?.meta_desc} />
        <meta name="og:description" content={selectedCategory?.meta_desc} />
        <meta name="og:title" content={selectedCategory?.meta_title} />
        <link rel="canonical" href={url} />
      </Helmet>{" "}
      {mobile ? (
        <CategoryPageSmallMobile />
      ) : (
        <div className="hidden lg:grid lg:grid-cols-4 gap-8 w-full container_1 py-8">
          <span className="col-span-1 hidden lg:inline">
            <FilterCategory
              name={selectedCategory.name}
              handleSubmit={handleSubmit}
              formik={formik}
              dealerData={dealerData}
            />
          </span>
          <span className="col-span-3 pt-4  flex-col gap-7 mt-8  hidden lg:flex">
            <Products />
          </span>
        </div>
      )}
    </>
  );
};

export default Categorypage;
